export default "/images/icons8-singapore.png?9cc97c324b4c2617eb797fb8a30bd33c";